import { render } from "./Leadership.vue?vue&type=template&id=24fb7938&scoped=true"
import script from "./Leadership.vue?vue&type=script&lang=js"
export * from "./Leadership.vue?vue&type=script&lang=js"

import "./Leadership.vue?vue&type=style&index=0&id=24fb7938&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fb7938"]])

export default __exports__